import { createBrowserRouter } from "react-router-dom";
import DashBoardLayout from "../../Layout/DashBoardLayout";
import Main from "../../Layout/Main";
import Blogs from "../../Page/Blogs/Blogs";
import AddProduct from "../../Page/Dashboard/Seller/AddProduct";
import AddCategory from "../../Page/Dashboard/Admin/AddCategory";
import Category from "../../Page/Dashboard/Admin/Category";
import ProductsManager from "../../Page/Dashboard/Admin/Products";
import VerificationRequest from "../../Page/Dashboard/Admin/VerificationRequest";
import AllAdmin from "../../Page/Dashboard/Admin/AllAdmin";
import AllBuyer from "../../Page/Dashboard/Admin/AllBuyer";
import AllSeller from "../../Page/Dashboard/Admin/AllSeller";
import Dashboard from "../../Page/Dashboard/Dashboard";
import MyOrders from "../../Page/Dashboard/Buyer/MyOrders";
import MyProducts from "../../Page/Dashboard/Seller/MyProducts";
import Payment from "../../Page/Dashboard/Payment";
import ReportedItem from "../../Page/Dashboard/Admin/ReportedItem";
import MyBuyer from "../../Page/Dashboard/Seller/MyBuyer";
import Home from "../../Page/Home/Home/Home";
import Login from "../../Page/Login/Login";
import Error from "../../Page/Shared/Error/Error";
import SignUp from "../../Page/SignUp/SignUp";
import AdminRoute from "../AdminRoute/AdminRoute";
import PrivateRoute from "../PrivateRoute/PrivateRoute";
import SellerRoute from "../SellerRoute/SellerRoute";
import LaptopLayout from "../../Layout/LaptopLayout";
import Laptop from "../../Page/Laptop/Laptop";
import MyWishlist from "../../Page/Dashboard/Buyer/MyWishlist";
import Profile from "../../Page/Dashboard/Profile/Profile";
import UpdateProfile from "../../Page/Dashboard/Profile/UpdateProfile";
// import UserRoute from "../UserRoute/UserRoute";

const routes = createBrowserRouter([
    {path: '/', element: <Main/>, children: [
        {path: '/', element: <Home/>},
        {path: '/login', element: <Login/>},
        {path: '/signup', element: <SignUp/>},
        {path: '/blog', element: <Blogs/>},
        // { path: '/category/:id', element: <PrivateRoute><Products /></PrivateRoute>, loader: ({ params }) => fetch(`${process.env.REACT_APP_API_URL}/category/${params.id}`)}
    ],
errorElement: <Error/>},
{
    path: 'category', element: <PrivateRoute><LaptopLayout /></PrivateRoute>, children: [
        {index: true , element: <PrivateRoute><Laptop/></PrivateRoute>},
        {path: '/category', element: <PrivateRoute><Laptop/></PrivateRoute>},
        { path: '/category/:id', element: <PrivateRoute><Laptop/></PrivateRoute>}
    ]
},
{
    path: '/dashboard', element: <PrivateRoute><DashBoardLayout/></PrivateRoute>, children: [
        {path: '/dashboard', element: <PrivateRoute><Dashboard/></PrivateRoute>},
        { path: '/dashboard/orders', element: <PrivateRoute><MyOrders /></PrivateRoute>},
        {path: '/dashboard/profile', element: <PrivateRoute><Profile /></PrivateRoute>},
        {path: '/dashboard/update-profile', element: <PrivateRoute><UpdateProfile /></PrivateRoute>},
        { path: '/dashboard/wishlist', element: <PrivateRoute><MyWishlist /></PrivateRoute>},
        { path: '/dashboard/add-product', element: <SellerRoute><AddProduct /></SellerRoute>},
        { path: '/dashboard/my-product', element: <SellerRoute><MyProducts /></SellerRoute>},
        { path: '/dashboard/my-buyers', element: <SellerRoute><MyBuyer /></SellerRoute>},
        { path: '/dashboard/admins', element: <AdminRoute><AllAdmin/></AdminRoute>},
        { path: '/dashboard/allbuyer', element: <AdminRoute><AllBuyer /></AdminRoute>},
        { path: '/dashboard/allseller', element: <AdminRoute><AllSeller /></AdminRoute>},
        { path: '/dashboard/add-category', element: <AdminRoute><AddCategory /></AdminRoute>},
        { path: '/dashboard/category', element: <AdminRoute><Category /></AdminRoute>},
        { path: '/dashboard/products', element: <AdminRoute><ProductsManager /></AdminRoute>},
        { path: '/dashboard/reportitem', element: <AdminRoute><ReportedItem /></AdminRoute>},
        { path: '/dashboard/verification-request', element: <AdminRoute><VerificationRequest/></AdminRoute>},
        {
            path: '/dashboard/payment/:id',
            element: <PrivateRoute><Payment /></PrivateRoute>,
        }
    ]
}
])

export default routes;